import { WizardSystem } from './WizardSystem';
export type { Step } from './types';

export default WizardSystem;